import Glide from "@glidejs/glide";
import { TESTIMONY_SLIDE } from "../constant";

class Slider {
  constructor(selector, config) {
    if (document.querySelector(selector)) {
      if (TESTIMONY_SLIDE.selector === selector) {
        const dotCount = document.querySelectorAll(`${selector}__slide`).length;
        let dotHTML = "";
        for (let i = 0; i < dotCount; i++) {
          dotHTML += `<button class='slider__bullet glide__bullet' data-glide-dir='=${i}' aria-label='slide-${i}'></button>`;
        }

        document
          .querySelector(".glide__bullets")
          .insertAdjacentHTML("beforeend", dotHTML);
      }

      new Glide(selector, config).mount();
    }
  }
}

export default Slider;
